import { IStationAssignFormValues } from '~providers/useForm/types';

export type UnpinningDetail = {
  reasonId: string | undefined;
  note: string | undefined;
};

/**
 * Picks the unpinning reason id and note that belong to a placement on the review step.
 *
 * The flow is derived exactly as `FormCreateProvider.handleSubmit` derives it, so the
 * review step shows the same values that are submitted. A drop station placement has
 * neither, and returns both as undefined.
 */
export const getPlacementUnpinningDetail = (
  placement: IStationAssignFormValues,
): UnpinningDetail => {
  if (!placement.placementId) {
    return { reasonId: undefined, note: undefined };
  }

  // Read per placement only, so a multi placement batch shows each placement's own
  // reason and note. `|| undefined` keeps a blank note off the card.
  if (placement.isRelocationFlow) {
    return {
      reasonId: placement.relocationReasonId || undefined,
      note: placement.relocationNote || undefined,
    };
  }

  if (placement.isPlacementAssignedStation) {
    return {
      reasonId: placement.swapReasonId || undefined,
      note: placement.swapNote || undefined,
    };
  }

  // Drop station: no unpinning happens, so there is nothing to show.
  return { reasonId: undefined, note: undefined };
};
